// extracted by mini-css-extract-plugin
export default {"report-payment-page":"ReportPaymentPage_report-payment-page__BSbQB"};